interface FieldProps {
  label: string;
  name: string;
  value: any;
  required?: boolean;
  onChange: (field: string, value: any) => void;
}

export const SelectField: React.FC<FieldProps & { options: { id: number; name: string }[] }> = ({
                                                                                                  label,
                                                                                                  required = false,
                                                                                                  value,
                                                                                                  name,
                                                                                                  onChange,
                                                                                                  options
                                                                                                }) => (
  <div className="form-group mb-5 d-flex items-center gap-4">
    <label>{required && <span className="text-danger h5">*</span>} {label}</label>
    <select className="form-select" value={value} required={required}
            onChange={(e) => onChange(name, +e.target.value)}>
      <option value="">-Выберите-</option>
      {options?.map((option) => (
        <option key={option.id} value={option.id}>{option.name}</option>
      ))}
    </select>
  </div>
);
